import React from "react"
import PropTypes from 'prop-types'
import { FormGroup } from "reactstrap"

import { connect } from "react-redux"
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  showRightSidebarAction,
} from "../../store/actions"

//SimpleBar
import SimpleBar from "simplebar-react"
import { Link } from "react-router-dom"

import "../../components/CommonForBoth/rightbar.css"

const RightSidebar = props => {
  return (
    <React.Fragment>
      <div className="right-bar">
        <SimpleBar style={{ height: "900px" }}>
          <div data-simplebar className="h-100">

            <div className="rightbar-title px-3 py-4">
              <Link to="#"
                onClick={e => {
                  e.preventDefault()
                  props.showRightSidebarAction(false)
                }}
                className="right-bar-toggle float-end"
              >
                <i className="mdi mdi-close noti-icon" />
              </Link>
              <h5 className="m-0">Dashboard Settings</h5>
            </div>

            <div className="p-4">

              <div className="radio-toolbar">
              
                <input
                  type="radio"
                  id="radioFluid"
                  name="radioWidth"
                  value="fluid"
                  checked={props.layoutWidth === "fluid"}
                  onChange={e => {
                    if (e.target.checked) {
                      props.changeLayoutWidth(e.target.value)
                    }
                  }}
                />

              </div>
              <hr className="mt-1" />

              <div className="radio-toolbar">
                <span className="mb-2 d-block" id="radio-title">
                  Choose Navbar Color
                </span>
                <input
                  type="radio"
                  id="radioThemeLight"
                  name="radioTheme"
                  value="light"
                  checked={props.topbarTheme === "light"}
                  onChange={e => {
                    if (e.target.checked) {
                      props.changeTopbarTheme(e.target.value)
                    }
                  }}
                />
                <label htmlFor="radioThemeLight" className="leftSidebar_white"> </label>
             
                <input
                  type="radio"
                  id="radioThemeDark"
                  name="radioTheme"
                  value="dark"
                  checked={props.topbarTheme === "dark"}
                  onChange={e => {
                    if (e.target.checked) {
                      props.changeTopbarTheme(e.target.value)
                    }
                  }}
                />
                <label htmlFor="radioThemeDark" className="leftSidebar_green"> </label>
              </div>

              {props.layoutType === "vertical" ? (
                <React.Fragment>

                <div className="radio-toolbar">

                <span className="mb-2 d-block" id="radio-title"> Choose Sidebar Color </span>


                <input
                  type="radio"
                  id="leftsidebarThemelight"
                  name="leftsidebarTheme"
                  value="white"
                  checked={props.leftSideBarTheme === "white"}
                  onChange={e => {
                    if (e.target.checked) {
                      props.changeSidebarTheme(e.target.value)
                    }
                  }}
                />
                <label htmlFor="leftsidebarThemelight" className="leftSidebar_white">  </label>

                <input
                  type="radio"
                  id="leftsidebarThemedark"
                  name="leftsidebarTheme"
                  value="dark"
                  checked={props.leftSideBarTheme === "dark"}
                  onChange={e => {
                    if (e.target.checked) {
                      props.changeSidebarTheme(e.target.value)
                    }
                  }}
                />

                <label htmlFor="leftsidebarThemedark" className="leftSidebar_green"> </label>

                {/* <input
                  type="radio"
                  id="leftsidebarThemecolored"
                  name="leftsidebarTheme"
                  value="colored"
                  checked={props.leftSideBarTheme === "colored"}
                  onChange={e => {
                    if (e.target.checked) {
                      props.changeSidebarTheme(e.target.value)
                    }
                  }}
                />

                <label htmlFor="leftsidebarThemecolored" className="leftSidebar_green_2"> </label> */}
                </div>

                  <hr className="mt-1" />
                  <div className="radio-toolbar">
                    <span className="mb-2 d-block" id="radio-title">
                     Choose Sidebar Type 
                    </span>
                    <input
                      type="radio"
                      id="sidebarDefault"
                      name="sidebarType"
                      value="default"
                      checked={props.leftSideBarType === "default"}
                      onChange={e => {
                        if (e.target.checked) {
                          props.changeSidebarType(e.target.value)
                        }
                      }}
                    />
                    <label htmlFor="sidebarDefault">Default</label>

                    <input
                      type="radio"
                      id="sidebarCompact"
                      name="sidebarType"
                      value="compact"
                      checked={props.leftSideBarType === "compact"}
                      onChange={e => {
                        if (e.target.checked) {
                          props.changeSidebarType(e.target.value)
                        }
                      }}
                    />
                 
                    <input
                      type="radio"
                      id="sidebarIcon"
                      name="sidebarType"
                      value="icon"
                      checked={props.leftSideBarType === "icon"}
                      onChange={e => {
                        if (e.target.checked) {
                          props.changeSidebarType(e.target.value)
                        }
                      }}
                    />
                    <label htmlFor="sidebarIcon">Only Icon </label>
                  </div>

                  <hr className="mt-1" />

                </React.Fragment>
              ) : null}

            </div>
          </div>
        </SimpleBar>
      </div>
      <div className="rightbar-overlay" />
    </React.Fragment>
  )
}

RightSidebar.propTypes = {
  changeLayout: PropTypes.func,
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  layoutType: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  topbarTheme: PropTypes.any,
  t: PropTypes.any
}

const mapStateToProps = state => {
  return { ...state.Layout }
}

export default connect(mapStateToProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeLayoutWidth,
  changeTopbarTheme,
  showRightSidebarAction,
})(RightSidebar)


